import styled from '@emotion/styled';
import React from 'react';
import { TestId } from '@components/test-ids';
import { ThemeProps } from '@theme/base';
import { boxShadowMixins } from '@styles/mixins';
import { Icon } from '../generic-icon';
import { OfferType } from '@model/offers/offers';
import { DestinationLink } from '../next-link';
import { TripTypes } from '@model/common';
import { useDispatch } from 'react-redux';
import { resetSelectedFilters } from '@state/slices/filters';
import { FiltersSideBarType } from '@model/filters';
import { RippleCard } from '@components/common/ripple-card';

/* ***************** *
 *       Types       *
 * ***************** */
export interface OfferTileProps {
  testId?: string;
  icon: string;
  title: string;
  description: string;
  offerType: OfferType;
  path: string;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const Container = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  height: '100%',
  alignItems: 'center',
  padding: theme.custom.spacing.large,
  border: `1px solid ${theme.custom.colors.group10.light}`,
  boxShadow: boxShadowMixins(theme.custom.colors.group10.lighter).lighter,
  color: theme.custom.colors.black,
  transition: `box-shadow ${theme.custom.transitions.default}`,

  ['&:hover']: {
    boxShadow: boxShadowMixins(theme.custom.colors.group10.base).default,

    [Title]: {
      color: theme.custom.colors.group1.base
    },
    [Description]: {
      color: theme.custom.colors.group1.base
    },
    ['i']: {
      color: theme.custom.colors.group1.base
    }
  },

  ['i']: {
    fontSize: '4rem',
    color: theme.custom.colors.group5.base,
    transition: `color ${theme.custom.transitions.default}`
  }
}));

const Title: any = styled.h5(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h5 as any),
  margin: '10px 0',
  transition: `color ${theme.custom.transitions.default}`
}));

const Description: any = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  margin: 0,
  transition: `color ${theme.custom.transitions.default}`
}));

/* ************************ *
 *    OfferTileComponent    *
 * ************************ */

export const OfferTile = ({ testId, icon, title, description, offerType, path }: OfferTileProps) => {
  const dispatch = useDispatch();
  return (
    <RippleCard style={{ borderRadius: '0px' }}>
      <DestinationLink path={path} tripType={TripTypes.HOLIDAYS} offerType={offerType}>
        <Container
          data-testid={testId || TestId.dynamicOffersComponent.tile}
          onClick={() => dispatch(resetSelectedFilters(FiltersSideBarType.SEARCH))}
        >
          <Icon name={icon} />
          <Title>{title}</Title>
          <Description>{description}</Description>
        </Container>
      </DestinationLink>
    </RippleCard>
  );
};
